const CATEGORY_RULES=[
  {
    category: 'Channels',
    keywords: ['channel','youtube','tiktok']
  },
  {
    category: 'Games',
    keywords: ['game','browser-game','endless runner','barkdash']
  },
  {
    category: 'AI & Creative',
    keywords: [
      'ai image',
      'ai design',
      'creative studio',
      'ai prompts',
      'seedance',
      'mocksy'
    ]
  },
  {
    category: 'Tools & Utilities',
    keywords: [
      'audio tool',
      'social media tool',
      'qr code',
      'marketing tool',
      'health',
      'medical',
      'downloader',
      'generator',
      'utility'
    ]
  }
];

export const PORTFOLIO_CATEGORY_ORDER=[
  'AI & Creative',
  'Tools & Utilities',
  'Games',
  'Channels',
  'Other Projects'
];

export function getSimplifiedPortfolioCategory(item) {
  const searchable=[
    item.title,
    item.category,
    item.subcategory,
    item.type
  ].filter(Boolean).join(' ').toLowerCase();

  const match=CATEGORY_RULES.find((rule)=>
    rule.keywords.some((keyword)=> searchable.includes(keyword))
  );

  return match?.category || 'Other Projects';
}

export function normalizePortfolioItem(item) {
  return {
    ...item,
    category: getSimplifiedPortfolioCategory(item)
  };
}

export function normalizePortfolioItems(items=[]) {
  return items.map(normalizePortfolioItem);
}